export const USER_INFO = {
  languageId: 1,
  name: "English (USA)",
  enabled: true,
  cultureName: "en",
  translatedName: "English (USA)",
};

export const MODULE_BRAND_KEYS = ["generic", "integratec", "memcor", "inge"];

export const UNITS = {
  HOURS: "hours",
  PERCENTAGE: "%",
};
